var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { setAccounts } from '@popup/steem/actions/account.actions';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { BackgroundCommand } from 'src/reference-data/background-message-key.enum';
import { Screen } from 'src/reference-data/screen.enum';
const AddAccountMain = ({ navigateTo, accounts, setAccounts, setTitleContainerProperties, }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_setup',
            isBackButtonEnabled: true,
            isCloseButtonDisabled: !accounts || !accounts.length,
        });
    });
    const handleAddByKeys = () => {
        navigateTo(Screen.ACCOUNT_PAGE_ADD_BY_KEYS);
    };
    const handleAddByAuth = () => {
        navigateTo(Screen.ACCOUNT_PAGE_ADD_BY_AUTH);
    };
    const handleImportKeys = () => {
        chrome.windows.getCurrent((currentWindow) => __awaiter(void 0, void 0, void 0, function* () {
            const win = {
                url: chrome.runtime.getURL('import-accounts.html'),
                type: 'popup',
                height: 600,
                //        width: 435,
                width: 400,
                left: currentWindow.width - 350 + currentWindow.left,
                top: currentWindow.top,
            };
            // Except on Firefox
            //@ts-ignore
            if (typeof InstallTrigger === undefined)
                win.focused = true;
            const window = yield chrome.windows.create(win);
            // setImportWindow(window.id);
            chrome.runtime.onMessage.addListener(onSentBackAccountsListener);
        }));
    };
    const onSentBackAccountsListener = (message) => {
        var _a;
        if (message.command === BackgroundCommand.SEND_BACK_IMPORTED_ACCOUNTS) {
            if (!(typeof message.value === 'string') &&
                ((_a = message.value) === null || _a === void 0 ? void 0 : _a.accounts.length)) {
                setAccounts(message.value.accounts);
            }
            chrome.runtime.onMessage.removeListener(onSentBackAccountsListener);
        }
    };
    return (React.createElement("div", { className: "add-account-page", "data-testid": `${Screen.ACCOUNT_PAGE_INIT_ACCOUNT}-page` },
        React.createElement("div", { className: "caption", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_chose_add_method'),
            } }),
        React.createElement("div", { className: "button-container" },
            React.createElement(ButtonComponent, { dataTestId: "add-by-keys-button", label: 'popup_html_add_by_keys', onClick: handleAddByKeys, type: ButtonType.ALTERNATIVE }))));
};
const mapStateToProps = (state) => {
    return {
        accounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    navigateTo,
    setAccounts,
    setTitleContainerProperties,
});
export const AddAccountMainComponent = connector(AddAccountMain);
